import React from "react";
import PropTypes from "prop-types";
import { OverlaySlider } from "../OverlaySlider";
import style from "./style.module.scss";

export function SliderGroup(props) {
  const onChangeHighlight = (params) => {
    props.changeHighlight({
      ...params,
      groupID: props.id,
    });
  };

  const renderSliders = () => {
    return props.sliders.map((slider, key) => (
      <GroupItem key={key} {...slider} onChange={onChangeHighlight} />
    ));
  };
  return (
    <div className={style.sliderGroup}>
      <span className={style.sliderGroup__label}>{props.label}</span>
      <div className={style.sliderGroup__item}>{renderSliders()}</div>
    </div>
  );
}

SliderGroup.propTypes = {
  /**
   * The prop that hold the unique id for the component
   */
  id: PropTypes.number.isRequired,
  /**
   * Label for the slider
   */
  label: PropTypes.number,
  /**
   * list of sliders you wanna display on group
   */
  sliders: PropTypes.array,
  /**
   * Callback function to be executed when selection sequence updated
   */
  changeHighlight: PropTypes.func,
};

function GroupItem(props) {
  const getHighlight = () => {
    const start = props.current.start;
    const size = props.current.text.length;
    return [start, size];
  };

  const sliderOnChange = (current) => {
    props.onChange({ current, sliderID: props.id });
  };

  return (
    <OverlaySlider
      sequence={props.sequence}
      highlight={getHighlight()}
      highlightClass={props.highlightClass}
      onChange={sliderOnChange}
      disable={props.disable}
      label={props.label}
    />
  );
}

GroupItem.propTypes = {
  /**
   * The string sequence to be displayed.
   */
  sequence: PropTypes.string,
  /**
   * The array to set the color of highlighting
   */
  highlightClass: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
  /**
   * Callback function to be executed when slider value changed
   */
  onChange: PropTypes.func,
  /**
   * Label for the slider
   */
  label: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
  /**
   * Boolean value specifying if slide is enable/disable
   */
  disable: PropTypes.bool,
  /**
   * The currently highlighted content
   */
  current: PropTypes.shape({
    /**
     * Text to be displayed in slider select
     */
    text: PropTypes.string,
    /**
     * The starting point of the highlighted text
     */
    start: PropTypes.string,
  }),
};
